import { APP_NAME, createAxiosInstance } from '@libs/typescript-utils'

export default createAxiosInstance({
  appName: APP_NAME.TMS,
})
